// SPDX-License-Identifier: AGPL-3.0-or-later

import RuntimeConfig from '@app/features/app/state/RuntimeConfig';
import {getDataFlx, getImageSizingProps} from '@app/features/ui/components/icons/BrandImageUtils';
import {msg} from '@lingui/core/macro';
import {useLingui} from '@lingui/react/macro';
import {observer} from 'mobx-react-lite';
import type React from 'react';

const LAFON_BRAND_LOGO_URL = 'https://lafon.com.tr/assets/logo-full.png';

const APPLICATION_ICON_DESCRIPTOR = msg({
	message: '{productName} application icon',
	comment: 'Accessible label for the Fluxer application icon.',
});
export const FluxerIcon = observer((props: React.SVGProps<SVGSVGElement>) => {
	const {i18n} = useLingui();
	const ariaLabel = i18n._(APPLICATION_ICON_DESCRIPTOR, {productName: RuntimeConfig.productName});
	const src = RuntimeConfig.iconUrl ?? RuntimeConfig.faviconUrl ?? LAFON_BRAND_LOGO_URL;
	const sizing = getImageSizingProps(props);
	return (
		<img
			{...sizing}
			src={src}
			alt={ariaLabel}
			style={{
				...(typeof sizing.style === 'object' && sizing.style != null ? sizing.style : null),
				objectFit: 'cover',
				objectPosition: 'left center',
				borderRadius: '50%',
			}}
			data-flx={getDataFlx(props, 'ui.icons.fluxer-icon.img')}
		/>
	);
});
